import { DateTimePicker as $DateTimePicker } from '@mantine/dates';
import type { DateTimePickerProps as $DateTimePickerProps } from '@mantine/dates';
import dayjs from 'dayjs';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type DateTimePickerProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<$DateTimePickerProps, 'value' | 'defaultValue'>;

export function DateTimePicker<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...props
}: DateTimePickerProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$DateTimePicker
      error={fieldState.error?.message}
      styles={{ input: { borderRadius: 8 } }}
      value={value}
      weekendDays={[]}
      onChange={(dateValue) => {
        // Mantine 8 hands over 'YYYY-MM-DD HH:mm:ss' strings; the forms work with Date objects.
        // dayjs parses that format in every browser, where new Date() fails in Safari.
        fieldOnChange(dateValue === null ? null : dayjs(dateValue).toDate());
        onChange?.(dateValue);
      }}
      {...field}
      {...props}
    />
  );
}
